import { useEffect, useState } from "react";
import { useRouteNode } from "react-router5";
import { Preview } from "./components/Article/Article";

export const useRouteName = () => {
  const { route } = useRouteNode("");
  const params = route.params;
  const topRouteName = route.name.split(".")[0];
  return topRouteName;
};
export const useRouteParams = () => {
  const { route } = useRouteNode("");
  const params = route.params;
  
  return params;
};

export const enableSmoothScrolling = () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (this: HTMLAnchorElement, e) {
      e.preventDefault();
      const href = this.getAttribute("href");
      if (!href) {
        return;
      }
      document.querySelector(href)?.scrollIntoView({
        behavior: "smooth",
      });
    });
  });
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const memoize = <T, A extends [], R>(fn : Func<T, A, R>) => {
  let cache : R | null = null;
  return function (this: T, ...args: A) {

    if (cache) {

      return cache;
    }
    else {

      cache = fn.apply(this, args);

      return cache;
    }
  }
}

class ResizeStore {
  width = window.innerWidth;
  constructor() {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
      this.sunscribersArray.forEach((f) => {
        f(this.width)
      })
    })
  }
  subscribers = new Set<((width: number) => void)>()
  sunscribersArray = [] as ((width: number) => void)[]
  subscribe(subscriber: (width: number) => void) {
    this.subscribers.add(subscriber);
    this.sunscribersArray =Array.from(this.subscribers); 
    subscriber(this.width);
    return () => {
      this.subscribers.delete(subscriber)
      this.sunscribersArray =Array.from(this.subscribers); 
    }
  }
}

const getResizeStore = memoize(() => {
  return new ResizeStore();
})

export const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState<number>(
   window.innerWidth,
  );
  useEffect(() => {
    // Handler to call on window resize
    getResizeStore().subscribe(setWindowSize)
  }, []); // Empty array ensures that effect is only run on mount
  return {width: windowSize};
}




type Func<T, A extends [], R> = (this: T, ...args: A) => R;





export const getCards = memoize( (): Promise<Preview[]> => {
  return new Promise((resolve) => {
    fetch(`/articles/preview`, {
      headers: {
        accept: "application/json",
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => resolve(data as Preview[]));
  });
})

export const sendGtag = (category: string, action: string, label: string) => {
  console.log(category, action, label);
  if(typeof gtag !== 'undefined'){
    gtag('event', action, {
      event_category: category,
      event_label: label
    })
  }
}